import cn from "./cn";

const PHP = new Intl.NumberFormat("en-PH", {
  style: "currency",
  currency: "PHP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * formatMoney — the canonical peso formatter for new and migrated work:
 * `₱1,234.56`, always two decimals, a leading minus for negatives.
 * Amounts are centavos by default (the API's money unit); pass
 * `{ unit: "pesos" }` for values already in pesos. Empty input renders "—".
 */
export function formatMoney(value, { unit = "cents" } = {}) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return PHP.format(unit === "cents" ? number / 100 : number);
}

/** Money — a formatted amount in tabular figures, ready for right alignment. */
export default function Money({ value, unit = "cents", className, ...props }) {
  return (
    <span className={cn("tabular-nums", className)} {...props}>
      {formatMoney(value, { unit })}
    </span>
  );
}
